export default {
  oma: {
    fromDate: "Date de début",
    toDate: "Date de fin",
    selectDate: "Sélectionner une date",
    cancel: "ANNULER",
    avocadoTreesList: "Liste des arbres d'avocat",
    addTreesManually: "Ajouter la géolocalisation des arbres manuellement",
    confirmationTitle: "Confirmation",
    confirmationMessage: "L'arbre d'avocat a été ajouté/modifié avec succès",
    addTreesBulk: "Importer les arbres en masse",
    addNewFarm: "Sélectionner la ferme",
    selectFarm: "Sélectionner la ferme",
    selectZone: "Sélectionner la zone",
    treeId: "ID de l'arbre",
    treeName: "Nom de l'arbre",
    zoneId: "ID de la zone",
    latitude: "Latitude",
    longitude: "Longitude",
    altitude: "Altitude",
    timestamp: "Horodatage",
    avocadoTrees: "Arbres d'avocat",
    // Land suitability
    landSuitibility: "Adéquation des terres",
    landSuitibilityReport: "Rapport sur l'adéquation des terres",
    generateNewReport: "Générer un nouveau rapport",
    operatorName: "Nom de l'opérateur",
    issueDate: "Date de publication",
    chooseYourLocation: "Choisissez votre emplacement",
    getLandEvaluation: "Obtenir une évaluation des terres",
    downloadPdfReport: "Télécharger le rapport PDF",
    pleaseEnterCoordinateText: 
      "Veuillez entrer les coordonnées (longitude et latitude) de l'emplacement de la ferme pour voir son score.",
    noRecordAvailable: "Aucun résultat disponible.",
    overallScoreForLand: "Score global pour l'adéquation des terres",
    landEvaluation: "Évaluation des terres",
    unsuitable: "Inadapté",
    marginally: "Marginalement",
    suitable: "Adapté",
    moderately: "Modérément",
    highly: "Très adapté",
    back: "Retour",
    search: "Rechercher",
    showResults: "Afficher les résultats",
    // Weather analysis
    weatherAnalysisReport: "Rapports d'analyse météo",
    weatherAnalysis: "Analyse météorologique",
    weatherReport: "Rapport météorologique",
    getWeatherAnalysis: "Obtenir l'analyse météorologique",
    filterByDate: "Filtrer par date",
    insertCoordinateText: 
      "Insérez les coordonnées de l'emplacement de la ferme (ou de l'arbre) ci-dessus, ou utilisez la carte ci-dessous pour indiquer l'emplacement de la ferme (ou de l'arbre).",
    addTreeGeolocation: "Ajouter la géolocalisation de l'arbre",
    editTreeGeolocation: "Modifier la géolocalisation de l'arbre",
    plantationDate: "Date de plantation",
    notes: "Notes",
    uploadTreeImages: "Télécharger les images des arbres",
    valueAtTheCoordinatesOfInterest: "Valeur aux coordonnées d'intérêt",
    "Slope (%)": "Pente (%)",
    "Soil texture (USDA class)": "Texture du sol (classe USDA)",
    "Coarse fragments (vol%)": "Fragments grossiers (vol%)",
    Land: "Terre",
    "Artificial surfaces (type)": "Surfaces artificielles (type)",
    "Proximity to Type 1 and 2 Roads (meters)": "Proximité des routes de type 1 et 2 (mètres)",
    "Soil Chemical Properties": "Propriétés chimiques du sol",
    "Soil Physical Properties": "Propriétés physiques du sol",
    "Soil organic carbon (%)": "Carbone organique du sol (%)",
    "Soil pH": "pH du sol",
    "Soil salinity (ECe))": "Salinité du sol (ECe))",
    "Mean annual temperature (°C)": "Température annuelle moyenne (°C)",
    Weather: "Météo",
    "Mean minimum temperature of coldest month (°C)": 
      "Température minimale moyenne du mois le plus froid (°C)",
    "Mean annual precipitation (mm)": "Précipitations annuelles moyennes (mm)",
    avocadoDetailNoUpdates: "Aucune mise à jour",
    avocadoTreeDetail: "Détails de l'arbre",
    avocadoTreeDetailHeader: "Détails de l'arbre d'avocat",
    avocadoTreeUpdates: "Mises à jour de l'arbre d'avocat",
    avocadoAddImages: "Ajouter de nouvelles images",
    addNewTreeImage: "Ajouter de nouvelles images d'arbre",
    selectCountry: "Sélectionner le pays",
    allRegions: "Toutes les régions",
    avocadoDetailCard: {
      clientTreeId: "ID de l'arbre",
      treeName: "Nom de l'arbre",
      latitude: "Latitude",
      longitude: "Longitude",
      altitude: "Altitude",
      zoneId: "ID de la zone",
      createdAt: "Date et heure",
      plantationDate: "Date et heure",
      updatedAt: "Dernière mise à jour",
    },
    importCSVFormat: "Importer au format CSV",
    importGeoJsonFormat: "Importer au format GeoJSON",
    importShapeFilesFormat: "Importer au format Shape Files",
    importXLSFormat: "Importer au format XLS",
    importGeobufFormat: "Importer au format Geobuf",
    importGeoPackageFormat: "Importer au format GeoPackage",
    importTopoJsonFormat: "Importer au format TopoJSON",
    avocadoTreeDetailsTableHeader: {
      updatedOn: "Mis à jour le",
      updatedBy: "Mis à jour par",
      notes: "Notes",
      noOfImages: "Nombre d'images",
      actions: "Action",
    },
    avocadoTreeView: "Vue de l'arbre",
    avocadoFarmView: "Vue de la ferme",
    avocadoTreeDetailPopupTitle: "Voir les détails de l'arbre",
    dateOfInterest: "Date d'intérêt",
    maximumCloudCoverage: "Couverture nuageuse maximale",
    import: "Importer",
    history: "Historique",
    downloandimport: "Télécharger et importer",
    importantNote: "Note importante",
    downloadXlsFormat: "Télécharger au format XLS",
    downloadCSVFormat: "Télécharger au format CSV",
    downloadGeoJSONFormat: "Télécharger au format GeoJSON",
    downloadTopoJSONFormat: "Télécharger au format TopoJSON",
    downloadGeoPackageFormat: "Télécharger au format GeoPackage",
    downloadGeobufFormat: "Télécharger au format Geobuf",
    selectXLSFile: "Sélectionner un fichier XLS",
    selectCSVFile: "Sélectionner un fichier CSV",
    selectGeoJSONFile: "Sélectionner un fichier GeoJSON",
    selectTopoJSONFile: "Sélectionner un fichier TopoJSON",
    selectGeoPackageFile: "Sélectionner un fichier GeoPackage",
    selectGeobufFile: "Sélectionner un fichier Geobuf",
    OrDragDrop: "ou faites glisser et déposez ici",
    importTrees: "Importer les arbres",
    importantNoteDetail: 
      "Veuillez utiliser les modèles fournis ci-dessus pour les téléchargements en masse.\n" +
      "Les autres formats entraîneront un échec.",
    fileName: "Nom du fichier",
    importedOn: "Importé le",
    status: "Statut",
    actions: "Action",
    action: "Action",
    download: "Télécharger",
    removeFile: "Supprimer le fichier",
    importedTrees: "Arbres importés",
    geolocation: "Géolocalisation",
    "Export CSV Format": "Exporter au format CSV",
    "Export XLSX Format": "Exporter au format XLSX",
    "Export PDF Format": "Exporter au format PDF",
    noHistoryFound: "Aucun historique trouvé",
  }
}
